import * as React from "react";
import { Building2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
const commercialServices = ["Purchase & Sale", "Property Development", "Commercial Leasing", "Landlord & Tenant Issues", "Contract Drafting", "Contract Review", "Negotiation", "Business Expansion", "Business Relocation", "Business Wind-down"];
export default function CommercialRealEstate() {
  return;
}